var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "standardized-phone-input" }, [
    _c("input", {
      ref: "phoneInput",
      class: _vm.inputClasses,
      attrs: {
        id: _vm.inputId,
        placeholder: _vm.currentPlaceholder,
        disabled: _vm.disabled,
        maxlength: _vm.maxLength,
        type: "tel",
        autocomplete: "tel",
      },
      domProps: { value: _vm.formattedValue },
      on: {
        input: _vm.handleInput,
        blur: _vm.handleBlur,
        focus: _vm.handleFocus,
        paste: _vm.handlePaste,
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }